module.exports = __webpack_public_path__ + "static/media/caret-down.516a3a35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadMore/caret-down.svg
// module id = 249
// module chunks = 0